import { useKaiProApiState } from '@kaiizen/kai-pro-api-react-state';

export const OfflineIndicatorIcon = ({ size = 32 }: { size?: number }) => (
  <svg width={size} height={size} viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <g clipPath='url(#clip0_41_8183)'>
      <path
        d='M21.1893 14.3827C22.2578 14.956 23.2279 15.6965 24.0627 16.576M8.64667 9.10934C6.9275 9.92921 5.35921 11.0336 4.008 12.376M28.008 12.632C26.4391 11.001 24.5567 9.70373 22.474 8.81818C20.3913 7.93263 18.1512 7.47701 15.888 7.47867M20.0853 20.5547C19.5774 19.9844 18.9587 19.5233 18.2671 19.1995C17.5754 18.8757 16.8252 18.6958 16.0619 18.6709C15.2986 18.6459 14.5381 18.7764 13.8268 19.0544C13.1155 19.3324 12.4681 19.7521 11.924 20.288M13.0667 13.412C11.1345 13.9116 9.36947 14.9151 7.952 16.32M16.0067 24.3867V24.3747M4 4.06134L28 27.976'
        stroke='#898989'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </g>
    <defs>
      <clipPath id='clip0_41_8183'>
        <rect width='32' height='32' fill='white' />
      </clipPath>
    </defs>
  </svg>
);

export const OnlineIndicatorIcon = ({ size = 32, stroke = '#91CD83' }: { size?: number; stroke?: string }) => (
  <svg width={size} height={size} viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <g clipPath='url(#clip0_41_8608)'>
      <path
        d='M4 12.4C5.58427 10.8257 7.46576 9.58222 9.53502 8.74177C11.6043 7.90131 13.82 7.4807 16.0533 7.5044C18.2866 7.52809 20.4929 7.99563 22.5439 8.87981C24.5948 9.76398 26.4495 11.0471 28 12.6547M24.056 16.6C23.0236 15.5097 21.7837 14.6366 20.4092 14.0322C19.0347 13.4278 17.5532 13.1041 16.0519 13.0803C14.5505 13.0564 13.0595 13.3329 11.6665 13.8933C10.2735 14.4538 9.0065 15.287 7.94 16.344M20.0733 20.58C19.5653 20.0095 18.9467 19.5483 18.2549 19.2243C17.5631 18.9004 16.8127 18.7205 16.0492 18.6955C15.2857 18.6706 14.5252 18.8011 13.8137 19.0792C13.1023 19.3574 12.4548 19.7772 11.9107 20.3133M16 24.408V24.4'
        stroke={stroke}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </g>
    <defs>
      <clipPath id='clip0_41_8608'>
        <rect width='32' height='32' fill='white' />
      </clipPath>
    </defs>
  </svg>
);

export const OnlineStatusIcon = () => {
  const { isOffline } = useKaiProApiState();
  return isOffline ? <OfflineIndicatorIcon /> : <OnlineIndicatorIcon />;
};
